import { errorMessage } from "@lumora/bridge";
import { useState } from "react";
import { client } from "../client.js";

type PrintTarget = "real" | "sandbox";

/** Owner portal test-order control. Tenant comes from the signed-in JWT. */
export function OwnerApiPlayground() {
  const [target, setTarget] = useState<PrintTarget>("real");
  const [placeMsg, setPlaceMsg] = useState<string | null>(null);
  const [placeErr, setPlaceErr] = useState<string | null>(null);
  const [placing, setPlacing] = useState(false);

  const place = () => {
    if (placing) return;
    setPlaceMsg(null);
    setPlaceErr(null);
    setPlacing(true);
    void client
      .placeMyTestOrder(target)
      .then((order) => {
        setPlaceMsg(
          `Test order #${order.number} queued for the ${target === "sandbox" ? "sandbox printer" : "real kitchen"}.`,
        );
      })
      .catch((e: unknown) => setPlaceErr(errorMessage(e, "Test order failed")))
      .finally(() => setPlacing(false));
  };

  return (
    <section className="ops-panel" data-api-playground>
      <h2>API playground</h2>
      <p className="muted">
        Test order for your site. No card charge. The line comes from your menu. Sandbox prints
        only on your sandbox device. Real reaches your production kitchen.
      </p>
      <fieldset>
        <legend>Printer</legend>
        <label>
          <input
            type="radio"
            name="print-target"
            value="real"
            checked={target === "real"}
            onChange={() => setTarget("real")}
          />
          Real kitchen
        </label>
        <label>
          <input
            type="radio"
            name="print-target"
            value="sandbox"
            checked={target === "sandbox"}
            onChange={() => setTarget("sandbox")}
          />
          Sandbox device
        </label>
      </fieldset>
      <button type="button" className="ops-btn" disabled={placing} onClick={place}>
        Place test order
      </button>
      {placeMsg ? <p className="muted">{placeMsg}</p> : null}
      {placeErr ? <p className="ops-error">{placeErr}</p> : null}
    </section>
  );
}
